<ng-container>
  @if (!transaction?.isStatus('finished')) {
    <div class="title-note mr-5" [ngClass]="{ 'mr-5': canOpen }">
      @if (canOpen && !isFiatTx()) {
        @if (hasCryptoTxStatusTag) {
          <span
            class="title-note-inner"
				[ngClass]="{
					'mod-pending': isPending,
					'mod-cancelled': transaction?.isCanceled()
				}"
            >
            {{ transaction?.getStatus() | translate }}
          </span>
        }
        @if (isUserInvitation) {
          <span class="title-note-inner mod-pending mr-5">{{ "pending" | translate }}</span>
        }
        @if (newUserInvited) {
          <span class="title-note-inner mr-5">{{ transaction?.getStatus() | translate }}</span>
        }
      }
      @if (canOpen && isFiatTx()) {
        @if (!isSEPAWithdrawProcessing() && !isWithdrawPending) {
          <span
            class="title-note-inner"
				[ngClass]="{
					'mod-pending': getPendingMod(),
					'mod-cancelled': transaction?.isCanceled()
				}"
            >
            {{ transaction?.getStatus() | translate }}
          </span>
        }
        @if (isWithdrawPending) {
          <span class="title-note-inner mod-pending">
            {{ transaction?.getStatus() | translate }}
          </span>
        }
      }
      @if (!isDebitCardTx()) {
        <a
          class="title-note-inner-link"
          [href]="getHDArticle()"
          [target]="'_blank'"
          [tabIndex]="-1"
          >
          @if (transaction?.getStatus().length > 0 && !canOpen) {
            <span
              class="bpi__icon-info text-blue font-size-13 mod-info ml-5 mr-5"
              [bp-tooltip]="'transaction_unconfirmed_tooltip' | translate"
            position="top"></span>
          }
        </a>
      }
    </div>
  }
  @if (tagArray.length > 0) {
    <div class="title-note" [ngClass]="{ 'mod-activity-tag-container': !!isActivity }">
      @for (tag of tagArray; track tag) {
        <span
          class="title-note-inner mod-tag"
				[ngClass]="{
					isOpen: !canOpen && hasMultipleTagsPerListItem(),
					'mr-5': canOpen || tagArray.length > 1
				}">
          {{ tag | translate }}
        </span>
      }
    </div>
  }
</ng-container>
